import { render, staticRenderFns } from "./zhibo.vue?vue&type=template&id=38339632&scoped=true&"
import script from "./zhibo.vue?vue&type=script&lang=js&"
export * from "./zhibo.vue?vue&type=script&lang=js&"
import style0 from "./zhibo.vue?vue&type=style&index=0&id=38339632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38339632",
  null
  
)

export default component.exports